import TomSelect from "tom-select";
import tippy, {Placement} from "tippy.js";
import Swiper from 'swiper';
import {Autoplay, EffectFade, Mousewheel, Pagination, Scrollbar} from 'swiper/modules';
import axios from "axios";
import {Modal} from "./modal";
import AirDatepicker from "air-datepicker";
import Treeselect, {OptionType} from 'treeselectjs';

export function activeLinks(document: Document) {
    document.querySelectorAll('.main-menu .links a').forEach((a: HTMLAnchorElement) => {
        a.classList.remove('active');
        if (a.href !== `${window.location.origin}/` && window.location.href.startsWith(a.href)) {
            a.classList.add('active');
        }
        if (a.href === `${window.location.origin}/` && a.href === window.location.href) {
            a.classList.add('active');
        }
    });
}

export function registerAlert() {
    document.querySelectorAll('.alert .close').forEach(button => {
        button.addEventListener('click', event => {
            const target = event.target as HTMLButtonElement;
            target.parentElement.remove();
        });
    });
}

export function registerServicesTabs(document: Document) {
    document.querySelectorAll('.service-block.main .tabs .name').forEach((element: HTMLElement) => {
        element.addEventListener('click', event => {
            const tab = event.currentTarget as HTMLElement;
            const parent = tab.closest('.item');
            const idList = tab.dataset.id.split('|');
            parent.querySelectorAll('.service-block.main .tabs .name').forEach((e: HTMLElement) => {
                e.classList.remove('selected');
            });
            tab.classList.add('selected');
            parent.querySelectorAll('.services .service').forEach((e: HTMLElement) => {
                e.classList.add('hidden');
            });
            parent.querySelectorAll('.services .actions .button[data-id]').forEach(e => {
                e.classList.add('hidden');
            })
            idList.forEach(id => {
                if (parent.querySelectorAll(`.services .service[data-id="${id}"]`).length === 0) {
                    parent.querySelectorAll('.services .service').forEach((e: HTMLElement) => {
                        e.classList.remove('hidden');
                    });
                } else {
                    parent.querySelectorAll(`.services .service[data-id="${id}"]`).forEach((e: HTMLElement) => {
                        e.classList.remove('hidden');
                    });
                }
                parent.querySelectorAll(`.services .actions .button[data-id="${id}"]`).forEach(e => {
                    e.classList.remove('hidden');
                })
            });
        });
    });
}

export function registerServiceTabs(document: Document) {
    document.querySelectorAll('.service-block.group .tabs .name').forEach((element: HTMLElement) => {
        element.addEventListener('click', event => {
            const tab = event.currentTarget as HTMLElement;
            const e = document.querySelector(`.service-block.group .groups .name[data-id="${tab.dataset.id}"]`)
            e.scrollIntoView({behavior: "smooth"});
        });
    });
}

export function registerModal(document: Document) {
    document.querySelectorAll('[data-modal]').forEach(element => {
        element.addEventListener('click', function (event) {
            const target = event.currentTarget as HTMLLinkElement;
            event.preventDefault();

            axios({
                url: target.href,
            }).then(result => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(result.data, 'text/html');
                const inputForm = htmlDoc.querySelector(target.dataset.modal) as HTMLElement;

                const modal = new Modal(inputForm);
                modal.open();
            });
        });
    });
}

export function registerDatePiker(document: Document) {
    const element = document.querySelector('.datepicker') as HTMLElement;
    if (element && !element.hasAttribute('data-datepicker')) {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        date.setHours(10);
        date.setMinutes(0);
        new AirDatepicker('.datepicker', {
            inline: true,
            dateFormat: 'yyyy-MM-dd',
            timepicker: true,
            minHours: 10,
            maxHours: 21,
            minutesStep: 30,
            startDate: date,
            selectedDates: [date],
            minDate: new Date(),
        });
        element.setAttribute('data-datepicker', '');
    }
}

export function registerTooltip(document: Document) {
    document.querySelectorAll('[data-tooltip]').forEach((element: HTMLElement) => {
        tippy(element, {
            content: element.dataset.tooltip,
            allowHTML: true,
            placement: element.dataset.tooltipPos as Placement,
        });
    });
}

export function registerOneTooltip(element: HTMLElement) {
    tippy(element, {
        content: element.dataset.tooltip,
        allowHTML: true,
        placement: element.dataset.tooltipPos as Placement,
    });
}

export function registerSelect(document: Document) {
    document.querySelectorAll('.tom-select').forEach((e: HTMLSelectElement) => {
        let plugins = [];
        if (e.multiple === true) {
            plugins = ['remove_button', 'clear_button', 'drag_drop'];
        }
        const s = new TomSelect(e, {
            delimiter: '|',
            hideSelected: true,
            plugins,
            placeholder: e.dataset.placeholder,
            hidePlaceholder: true,
            maxOptions: Number.MAX_VALUE,
            create: (Boolean)(e.dataset.create),
            allowEmptyOption: true,
            render: {
                no_results: (data, escape) => {
                    return '<div class="no-results">Не найдено "' + escape(data.input) + '"</div>';
                },
                option_create: (data, escape) => {
                    return '<div class="create active">Создать "' + escape(data.input) + '"</div>';
                },
                option: function (data: { icon: any; text: any; }, escape: (arg0: any) => string) {
                    let icon = '';
                    if (data.icon) {
                        icon = '<span class="' + escape(data.icon) + '"></span>';
                    }
                    return '<div>' + icon + escape(data.text) + '</div>';
                },
                item: function (data, escape) {
                    let icon = '';
                    if (data.icon) {
                        icon = '<span class="' + escape(data.icon) + '"></span>';
                    }
                    return '<div>' + icon + escape(data.text) + '</div>';
                },
            },
        });
        s.on('item_add', (value: string) => {
            if (value.split('|').length === 2) {
                const group = value.split('|')[0];
                s.items.forEach(i => {
                    if (i !== value) {
                        if (i.split('|')[0] === group) {
                            s.removeItem(i);
                        }
                    }
                });
                s.refreshOptions();
            }
        });
    })
}

export function registerSwiper(document: Document) {
    Swiper.use([Autoplay, EffectFade, Mousewheel, Pagination, Scrollbar]);
    new Swiper('.review-swiper', {
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
        },
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        grabCursor: true,
    });
    new Swiper('.blog-swiper', {
        slidesPerView: 2,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
        },
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        grabCursor: true,
    });
    new Swiper('.images-swiper', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        grabCursor: true,
    });
    new Swiper('.services.swiper-container', {
        slidesPerView: 5,
        loop: true,
        spaceBetween: 50,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
            dynamicMainBullets: 5,
        },
    });
}

export function registerTreeSelect(document: Document) {
    const collect = (select: HTMLSelectElement, parent: number): OptionType[] => {
        const options = [];
        select.querySelectorAll(`[data-parent="${parent}"]`).forEach((option: HTMLOptionElement) => {
            const item = {
                name: option.innerText,
                value: option.value,
                children: collect(select, Number(option.value)),
            };
            options.push(item);
        });

        return options;
    };
    document.querySelectorAll('.tree-select').forEach((element: HTMLSelectElement) => {
        const treeSelect = new Treeselect({
            placeholder: 'Выбрать ... ',
            parentHtmlContainer: element.parentElement,
            value: Array.from(element.children).filter((o: HTMLOptionElement) => o.selected).map(o=>o.value),
            options: collect(element, 0),
            isSingleSelect: !element.multiple,
        });
        treeSelect.srcElement.addEventListener('input', (e: CustomEvent) => {
            element.value = "";
            e.detail.forEach((id: number) => {
                const o: HTMLOptionElement = element.querySelector(`[value="${id}"]`);
                o.selected = true;
            });
        });
    });
}
